import React, { useState, useRef, useEffect, useCallback } from "react";
import { useToast } from "../../Utils/toastContext";
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";
import { debounce } from "lodash";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setFileIdsRedux,
  clearFileIdsRedux,
} from "../../Redux/store/userSlice";
export default function CommentInput({
  comment,
  setComment,
  handlSendComment,
  setLoading,
}) {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const dispatch = useDispatch();
  const [showEmojis, setShowEmojis] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileIds, setFileIds] = useState([]);

  const emojiRef = useRef(null);
  const navigate = useNavigate();
  const toggleEmojiPicker = () => setShowEmojis(!showEmojis);

  const addEmoji = (emoji) => {
    setComment((prev) => prev + emoji.native);
  };
  const fileUploadNew = async (file) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/files/upload`;
    const formData3 = new FormData();
    formData3.append("file", file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        handleUploadFileAttorney(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };

  const removeFile = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
    setFileIds((prev) => prev.filter((_, i) => i !== index));
  };

  const handleClickOutside = (e) => {
    if (emojiRef.current && !emojiRef.current.contains(e.target)) {
      setShowEmojis(false);
    }
  };
  const handleUploadFileAttorney = useCallback(
    debounce(async (fileUploaded) => {
      let toastMessage = null;
      try {
        const response = await fileUploadNew(fileUploaded);
        if (response.status == 201) {
          const fileUploaded = response.data; // file info
          const uploadedFileId = response.data.file_id;

          setSelectedFiles((prev) => [...prev, fileUploaded]);
          setFileIds((prev) => [...prev, uploadedFileId]);
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [] // Dependencies
  );
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    if (fileIds.length > 0) {
      dispatch(setFileIdsRedux(fileIds));
    } else {
      dispatch(clearFileIdsRedux());
    }
  }, [fileIds]);
  return (
    <div className="border-t bg-white px-3 py-3 sm:px-5 sm:py-4 sticky bottom-0 shadow-md">
      <div className="relative w-full flex items-center space-x-2">
        {/* File Upload Button */}
        <label
          className="p-2 text-gray-500 hover:text-[#1A4CB4] cursor-pointer transition"
          title="Attach file"
        >
          <img src="/file-clip.svg" alt="file-clip" className="w-4 h-4" />{" "}
          <input
            type="file"
            multiple
            className="hidden"
            onChange={handleFileChange}
          />
        </label>

        {/* Input Field */}
        <div className="flex-1 relative">
          <input
            type="text"
            placeholder="Type a message..."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            className="w-full border-l-2 border-gray-300  px-4 py-2.5 sm:py-3 text-sm sm:text-base  focus:outline-none pr-14"
          />

          {/* Emoji Picker Trigger (Left of Send Button) */}
          <div
            className="absolute right-10 top-1/2 transform -translate-y-1/2"
            ref={emojiRef}
          >
            <button
              onClick={toggleEmojiPicker}
              className="text-gray-500 hover:text-[#1A4CB4] p-1 transition"
              title="Add emoji"
            >
              <img src="/smile.svg" alt="smile" className="w-4 h-4" />
            </button>

            {showEmojis && (
              <div className="absolute bottom-12 right-0 z-50">
                <Picker
                  data={data}
                  onEmojiSelect={addEmoji}
                  theme="light"
                  previewPosition="none"
                />
              </div>
            )}
          </div>

          {/* Send Button */}
          <button
            onClick={(e) => {
              if (!comment && fileIds.length === 0) {
                showToast("Please enter a comment or attach a file", "error");
                return;
              }
              setLoading(true);
              handlSendComment(e, "comment", fileIds);
            }}
            className="absolute right-2 top-1/2 transform -translate-y-1/2 text-[#1A4CB4] hover:text-[#0F2C82] transition-all"
          >
            <img
              src="/send-icon.svg"
              alt="send"
              className="w-5 h-5 sm:w-6 sm:h-6"
            />
          </button>
        </div>
      </div>

      {/* Display Selected Files */}
      {selectedFiles.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-3">
          {selectedFiles.map((file, index) => (
            <div
              key={index}
              className="flex items-center bg-gray-100 px-3 py-1 rounded-full text-xs text-gray-700 shadow-sm"
            >
              <span className="truncate max-w-[150px]">{file.file_name}</span>
              <button
                onClick={() => removeFile(index)}
                className="ml-2 text-red-500 hover:text-red-700 font-bold"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
